import useSWR from 'swr';

import { useApi } from '@/hooks/api';

interface Fave {
	guide_id?: string;
	program_id?: string;
	// Always present, and null rather than absent when the entry has been unfaved — the server
	// derives it as `deleted_at ? null : updated_at`. Testing for the key instead of its value
	// therefore reads an unfaved entry as faved.
	faved_at?: Date | null;
	unfaved_at?: Date;
}

export const useFaves = () => {
	const apiRequest = useApi();

	const { data, error, mutate } = useSWR<Fave[]>(
		'faves',
		async (endpoint: string) => {
			const res = await apiRequest<{ faves: Fave[] }>({
				endpoint,
				method: 'GET',
				noCache: true,
			});
			return res.data.faves;
		},
		{ revalidateOnFocus: false },
	);

	return {
		isFetching: !data && !error,
		faves: data,
		error,
		mutate,
	};
};
